import moment from 'moment';

export default function lsDateFilter(dateString) {
    return moment(dateString).format('ddd, MMM D');
}
